export const SUBMIT_RFI_SUPPORT_TICKET_INIT = 'SUBMIT_RFI_SUPPORT_TICKET_INIT';
export const SUBMIT_RFI_SUPPORT_TICKET_SUCCESS = 'SUBMIT_RFI_SUPPORT_TICKET_SUCCESS';
export const SUBMIT_RFI_SUPPORT_TICKET_ERROR = 'SUBMIT_RFI_SUPPORT_TICKET_ERROR';
export const SUBMIT_RFI_SUPPORT_TICKET_RESET = 'SUBMIT_RFI_SUPPORT_TICKET_RESET';

export const submitRFISupportTicketInit = () => ({
  type: SUBMIT_RFI_SUPPORT_TICKET_INIT,
});

export function submitRFISupportTicketResponse(data) {
  if (data === "success") {
    return {
      type: SUBMIT_RFI_SUPPORT_TICKET_SUCCESS,
    }
  } else {
    return {
      type: SUBMIT_RFI_SUPPORT_TICKET_ERROR,
      data,
    }
  }
}

export const submitRFISupportTicketSuccess = () => ({
  type: SUBMIT_RFI_SUPPORT_TICKET_SUCCESS,
});

export const submitRFISupportTicketError = (error) => ({
  type: SUBMIT_RFI_SUPPORT_TICKET_ERROR,
  error,
});

export const submitRFISupportTicketReset = () => ({
  type: SUBMIT_RFI_SUPPORT_TICKET_RESET,
});